import React from 'react';
import Grid from '@mui/material/Grid';
import AutoSelect from '../../../containers/selects/auto_select';

const types = [
    {cod: 'MTS', name: 'Metros'},
    {cod: 'KG', name: 'Kilos'}
]

const AutoSelectTypeQuantity = (props) => {

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <AutoSelect
                    id='order_qtype'
                    label='Medida'
                    width={props.width}
                    getOptionLabel={(option) => `${option.cod}`}
                    renderOption={(props, option) => (<div {...props}>{option.name}</div>)}
                    data={types}
                    onChange={props.onChange ? (p) => props.onChange(p) : null}
                    value={types.length > 0 ? types[0] : null}
                />
            </Grid>
        </Grid>
    );

}

export default AutoSelectTypeQuantity;